<template>
  <div class="bodys">
    <Spin fix v-if="loading" />
    <template v-else>
      <p class="title">{{ date.title }}</p>
      <p class="vice">发布时间：{{ date.date }}</p>
      <div class="content" v-html="date.content"></div>
    </template>
    <Button
      class="btn"
      icon="md-return-left"
      type="primary"
      shape="circle"
      @click="handleBack"
    />
  </div>
</template>

<script>
import { GetNewsinfoByID } from '@api' 
import { escapeToHtml, formatDate } from '@libs/util'
export default {
  name: 'news-content-mobile',
  data () {
    return {
      date: {},
      loading: false,
      infoId: '',
      type: ''
    }
  },
  mounted () {
    const { type, id } = this.$route.query
    this.infoId = id
    this.type = type
    this.getContent()
  },
  methods: {
    async getContent () {
      this.loading = true
      try {
        const query = { ID: this.infoId }
        const { data: { NEWSTITLE, NEWSDATETIME, NEWSNOTE } } = await GetNewsinfoByID(query)
        this.date = {
          title: NEWSTITLE,
          date: formatDate(NEWSDATETIME),
          content: escapeToHtml(NEWSNOTE)
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    handleBack () {
      const { type } = this
      this.$router.replace({
        name: 'news',
        query: { type }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
.bodys {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 16px;
  overflow: auto;
}
.title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.vice {
  text-align: center;
  font-size: 12px;
  margin: 25px 0;
}
.content {
  font-size: 16px;
}
.btn {
  width: 50px !important;
  height: 50px !important;
  position: fixed;
  z-index: 9999;
  bottom: 50px;
  right: 50px;
}
</style>
